import { Component, Input, OnInit, Output ,inject,DestroyRef} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import { extendedRaterFile } from "src/app/shared/services/external-ts-files/extended-rating-mapper";
import { NgIf, NgFor } from '@angular/common';
import { ResponseControllerComponent } from './response-controller/response-controller.component';
import { LtmsLoaderComponent } from '../../../ltms-loader/ltms-loader.component';
import { OrderByPipe } from '../../../../pipes/order-by/order-by.pipe';

@Component({
    selector: 'app-response-panel',
    templateUrl: './response-panel.component.html',
    styleUrls: ['./response-panel.component.scss'],
    imports: [NgIf, NgFor, ResponseControllerComponent, LtmsLoaderComponent, OrderByPipe]
})
export class ResponsePanelComponent implements OnInit {
  @Input() feedId: string = "";
  @Input() feedData: any = [];
  @Input() brandDetails: any = {}
  destroyRef = inject(DestroyRef)
  statusList: any = [
    {
      "uuid": "69c75f8d-c7ab-4d4e-af05-2667027d939c",
      "name": "Open",
      "sequence": 1,
      "color": "#c09853"
    },
    {
      "uuid": "c9f7e26d-99fe-42fb-8048-7192acf06e44",
      "name": "In-progress",
      "sequence": 2,
      "color": "#5a5a5a"
    },
    {
      "uuid": "684c0b3e-78c1-4ebe-b550-2a745d1bc5ca",
      "name": "On-hold",
      "sequence": 3,
      "color": "#b94a48"
    },
    {
      "uuid": "c71a8524-7fc4-49d3-894a-2555dcc6ed07",
      "name": "Closed",
      "sequence": 4,
      "color": "#468847"
    }
  ]
  fieldDetails: any = [];
  feedDetails: any = {}
  selectedStatus: any = {}
  tempStatus: any = {}
  questionMapping: any = {}
  statusConfig: any = {}
  offsetMapping:any = {};
  isControlPanelLoaded:boolean = false;
  isResponsePanelLoaded:boolean = false;
  extenderRatingMapper = new extendedRaterFile();
  constructor(
    private _helpers: HelpersService,
    private _feedService: FeedsService,
    private _ltmsEvent:LtmsEventHandlerService
  ) { }
  ngOnInit(): void {

  }

  ngOnChanges() {
    this.isResponsePanelLoaded = false;
    this.resetData();
    this.offsetMapping = this._helpers.getBrandTimezoneDetails(this.brandDetails)
    this.feedDetails = _.get(this.clone(this.feedData), 'feed', {});
    const detailedFeedbackItems = _.get(this.clone(this.feedData), 'detailed_feedback_items', []);
    this.feedDetails.comments = _.get(this.feedDetails, 'feed_params.comments', '');
    this.feedDetails.primary_rating = _.get(this.feedDetails, 'feed_params.primary_rating', null);
    this.feedDetails.received_on = this._helpers.getTimeByOffset(this.offsetMapping["__zone_symbol__value"]['offset'], _.get(this.feedDetails, 'created_date'), "DD MMM 'YY HH:mm");
    if (detailedFeedbackItems.length) {
      this.processQuestionData(detailedFeedbackItems);
    }
  }
  resetData() {
    this.fieldDetails = [];
    this.feedDetails = {}
    this.selectedStatus = {}
    this.tempStatus = {}
    this.questionMapping = {}
    this.statusConfig = {}
  }
  processQuestionData(detailedFeedbackItems: any) {
    this.questionMapping = this.getQuestionMapping(detailedFeedbackItems);

    const primaryRatingDetail: any = this.questionMapping['primary_rating'];
    if (primaryRatingDetail && !_.isEmpty(primaryRatingDetail.prop) && primaryRatingDetail.prop[this.feedDetails.primary_rating]) {
      const prop: any = primaryRatingDetail.prop[this.feedDetails.primary_rating];
      this.feedDetails.primary_rating_color = prop.active_color
    }
    
    if(_.isNull(this.feedDetails.primary_rating)){
      this.feedDetails.primary_rating = 'NA';
      this.feedDetails.primary_rating_color = '#00000033'
    }
    if (_.hasIn(this.feedDetails, 'feed_params.detailed_rating') && !_.isEmpty(this.feedDetails.feed_params.detailed_rating)) {
      const ratings = this.clone(this.feedDetails.feed_params.detailed_rating);
      let questionByGroupId = _.groupBy(ratings, (rating: any) => {
        return rating.group_id;
      });
      _.each(questionByGroupId, (value: any, group_key: string) => {
        if (group_key != "undefined") {
          const questionDetails = this.questionMapping[group_key];
          if (questionDetails) {
            const response = this.getResponseForMultiSelectQuestion(value);
            this.fieldDetails.push({
              label: questionDetails.question,
              values: response,
              seq_no: questionDetails.seq_no,
              is_displayed_on_dashboard: questionDetails.is_displayed_on_dashboard,
              component_type: (_.get(questionDetails, "interaction_type") == "multi-select") ? questionDetails.question_component_type : questionDetails.component_type,
              interaction_type: questionDetails.interaction_type ? questionDetails.interaction_type : "null"
            })
          }
        }
      })

      let questionWithoutGroupId = questionByGroupId['undefined'];
      if (questionWithoutGroupId) {
        // If there are questions without groupId
        _.each(questionWithoutGroupId, (question: any) => {
          const questionDetails = this.questionMapping[question.field_id]
          var ratingMessage = null;
          if (questionDetails && questionDetails.question) {
            question.question_id = question.field_id;
            question.label = questionDetails.question;
            question.is_displayed_on_dashboard = questionDetails.is_displayed_on_dashboard;
            // Add question sequence in the question
            question.seq_no = questionDetails.seq_no;

            // Include if rating > 0
            if ('rating' in question) {
              if (questionDetails.prop && questionDetails.prop[question.rating] && questionDetails.prop[question.rating].label) {
                question.ratingMessage = questionDetails.prop[question.rating].label;
              } else {
                question.ratingMessage = question.rating;
              }

              if (question.component_type == 'ltms-nps-five-star-rater' && this.feedData.feed && this.feedData.feed.feed_params && this.feedData.feed.feed_params.primary_rating && this.feedData.feed.mainRaterType && this.feedData.feed.extendedRaterType) {
                question.actual_rating = question.rating
                question.rating = this._helpers.getPrimaryRating({
                  rating: question.rating,
                  raterType: this.feedData.feed.mainRaterType,
                  extendedRaterType: this.feedData.feed.extendedRaterType
                });
              }
              // Check if the question is of a specific component type and if extended rater type is 4
              if(questionDetails.is_primary_rating && questionDetails.component_type == 'ltms-nps-five-star-rater' && this.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(this.brandDetails.extended_rating_mapper))) {
                // Get the updated distribution using dynamic mapping logic
                question.actual_rating = question.rating
                question.rating = this.extenderRatingMapper.getExtendedRaterMappingPrimaryRating(question.rating, questionDetails);
                question.ratingMessage = questionDetails.prop[question.actual_rating].label;
                this.feedDetails.primary_rating_color = questionDetails.prop[question.actual_rating].active_color;
              }
            }
            if (typeof question.rating == 'string' || question.comment) {
              question.ratingMessage = question.comment || question.rating;
              question.rating = question.comment || question.rating;

              if (question.comment_richtext) {
                question.rating = question.ratingMessage = question.comment_richtext
                question.isRichText = true;
              }
            }
          } else {
            question.ratingMessage = question.rating;
          }
          if (_.hasIn(questionDetails, 'interaction_type')) {
            question.interaction_type = questionDetails.interaction_type;
          }
          if (_.hasIn(questionDetails, 'component_type')) {
            question.component_type = questionDetails.component_type;
          }

          question.component_type = (_.get(questionDetails, "interaction_type") == "multi-select") ? questionDetails.question_component_type : _.get(questionDetails, "component_type") || question.component_type;

          // Get the first element where ratingMessage is an Array. Eg. ["NCR"]
          if (question.ratingMessage && _.isArray(question.ratingMessage)) {
            question.ratingMessage = question.ratingMessage.toString();
          }
          
          if(!question.group_id && question.question_type == "attachment"){
            if(question.rating && question.rating.length){
              question.values = this.prepareAttatchmentDetails(question.rating)
            }else{
              question.values = []
            }
            this.fieldDetails.push(question);
          }else if (!question.group_id) {
            
            if(question.question_type == 'text' || question.question_type == "single-select"){
              question.values = [`${question.ratingMessage}`];
            }else{
              question.values = [`(${question.rating}) ${question.ratingMessage}`];
            }
           
            this.fieldDetails.push(question);
          }
        });
      }
    }
    this.isResponsePanelLoaded = true;
    if(this.isResponsePanelLoaded && this.isControlPanelLoaded){
      this._ltmsEvent.emit('feed-detail-loaded');
    }
  }

  prepareAttatchmentDetails(attachments) {
    return _.map(attachments, (attachment: any) => {
      const nameArray = attachment.split("/");
      const name = nameArray[nameArray.length - 1]
      const extArr = name.split(".");
      const ext = extArr[extArr.length - 1];
      return {
        name: nameArray[nameArray.length - 1].replace("." + ext, ""),
        ext: "." + ext,
        value: attachment,
      }
    })
  }

  findQuestion(questionlist: any, fieldId: string) {
    return _.find(questionlist, (question: any) => {
      return (question.field_id == fieldId && !question.is_deleted)
    })
  }

  markFeedAsUnread() {
    this._feedService.markFeedAsUnread(_.get(this.feedDetails, '_id'), _.get(this.feedDetails, 'brand_id')).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      if (response && response.code === 0) {
        // getFeedsList(oldTargetId, oldDataFor, from, to, false, true);
        // toggleFeedListDetail(false);
        // this.togglePanel.emit(false) 
        this._ltmsEvent.emit('refresh-feed-list')
        this._feedService.showFeedDetails.set(false)
      } else { }
    })
  }

  getResponseForMultiSelectQuestion(responses) {
    let answer: any = [];
    var optionDetail = null;
    _.each(responses, (response: any) => {
      // Modified by Rumana on 05/04/2017: Instead of fetching prop of parent question, get the prop of the response
      optionDetail = this.questionMapping[response.field_id];
      if (optionDetail && optionDetail['prop'] && optionDetail['prop'][response.rating]) {
        const value = ((optionDetail['prop'][response.rating]['label']) ? optionDetail['prop'][response.rating]['label'] : response.rating);
        answer.push(value)
      } else {
        answer.push(response.rating)
      }
    });
    return answer;
  }

  getQuestionMapping(detailedFeedbackItems: any) {
    let map = {};
    _.each(detailedFeedbackItems, (question: any) => {
      map[question.field_id] = question;
    })
    return map;
  }

  // pepare assignee data 
  prepareHierarchAndAssigneData() {

  }

  createHashMap(list: any, key: string) {
    let map = {};// new Map();
    _.each(list, (obj: any) => {
      if (obj[key]) {
        map[obj[key]] = obj;
        // map.set(obj[key],obj;
      }
    });
    return map;
  }
  clone(data: any) {
    if (data) {
      return JSON.parse(JSON.stringify(data))
    } else {
      return data;
    }
  }
  isQuestionTypeAttachment(rating) {
    if (rating.question_type == "attachment") {
      return true;
    } else {
      return false;
    }
  }
  downloadAttachment(attachment: string) {
    this._feedService.downloadAttachment(attachment,this.brandDetails._id)
  }
  loadingChanged(event:any){
    this.isControlPanelLoaded = event
    if(this.isResponsePanelLoaded && this.isControlPanelLoaded){
      this._ltmsEvent.emit('feed-detail-loaded');
    }
  }
}
